import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  loading: true,
  extended: {},
  user: {},
  properties: {},
  verifications: {},
  completedReferences: {},
  createdReferences: {},
  outstandingReferences: {},
  counts: {
    "properties": 0,
    "verifications": 0,
    "completedReferences": 0,
    "createdReferences": 0,
    "outstandingReferences": 0
  },
  
  joiningExcellenceProgramme: false,
  joiningExcellenceProgrammeFailed: null,
  joinedExcellenceProgramme: false,

});

export default function dashboardReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_DASHBOARD_DATA:
      return state;
    case actions.SET_DASHBOARD_DATA:
      return state
        .set('loading', false)
        .set('properties', action.userData.properties)
        .set('verifications', action.userData.verifications)
        .set('completedReferences', action.userData.completedReferences)
        .set('createdReferences', action.userData.createdReferences)
        .set('outstandingReferences', action.userData.outstandingReferences)
        .set('counts', action.userData.counts)
    case actions.JOIN_EXCELLENCE_PROGRAMME:
      return state
        .set('joiningExcellenceProgramme', true)
        .set('joiningExcellenceProgrammeFailed', null)
        .set('joinedExcellenceProgramme', false)
    case actions.JOIN_EXCELLENCE_PROGRAMME_SUCCEEDED:
      return state
        .set('joiningExcellenceProgramme', false)
        .set('joiningExcellenceProgrammeFailed', null)
        .set('joinedExcellenceProgramme', action.payload)
    case actions.JOIN_EXCELLENCE_PROGRAMME_FAILED:
      return state
        .set('joiningExcellenceProgramme', false)
        .set('joiningExcellenceProgrammeFailed', action.payload)
        .set('joinedExcellenceProgramme', false)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/reducer.js